module.exports = __webpack_public_path__ + "static/desktop/img/purchase.00f3c782.svg";